/**
 * Calculates the check digit for a given register number and transaction ID.
 * @param registerNumber The register number.
 * @param transactionId The transaction ID. * IT MUST BE 4 DIGITS LONG * from testing this seems to be the case
 * @returns The calculated check digit.
 */
export const calculateCheckDigit = (
  registerNumber: string,
  transactionId: string,
) => {
  const paddedTransactionId = transactionId.padStart(4, '0');
  let value = `0${registerNumber}${paddedTransactionId}0`;
  // accept only digits, dashes or spaces
  if (/[^0-9-\s]+/.test(value)) return '';

  // The Luhn Algorithm to calculate the check digit
  let checkDigit = 0;
  let digit = 0;
  let isEven = false;
  value = value.replace(/\D/g, '');

  for (let n = value.length - 1; n >= 0; n -= 1) {
    digit = parseInt(value.charAt(n), 10); // Ensure digit is a number

    if (isEven) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    checkDigit += digit;
    isEven = !isEven;
  }
  checkDigit %= 10;
  if (checkDigit !== 0) checkDigit = 10 - checkDigit;
  return checkDigit.toString();
};

/**
 * Extracts receipt info from a Home Depot receipt string.
 * @param receiptText - Raw receipt text
 * @returns Receipt number in the format: STORE-REGISTER-TRANSACTION-CHECKDIGIT
 */
export const extractReceiptNumber = (receiptText: string): string | null => {
  // Match a line with store, register, transaction, date, and some other number
  const match = receiptText.match(/(\d{4})\s+(\d{2,5})\s+(\d{4,6})/);
  if (!match) return null;

  const registerNumber = match[2];
  const transactionId = match[3];

  // Format as needed (e.g., with hyphens)
  return `${registerNumber.padStart(5, '0')}-${transactionId.padStart(5, '0')}`;
};
